// Generated from b2bservices/src/common/productRequirements/categories.ts.
// Do not edit. Run yarn requirements:sync in a paired checkout.

import type { CategoryNode, ProductCategory, ProductValues } from './types';

export type CategoryPredicate = (category?: ProductCategory, rootCategory?: CategoryNode,
  state?: ProductValues, categoryPath?: readonly string[]) => boolean;

export const productCategoryPath = (category: ProductCategory | undefined, root: CategoryNode | undefined): string[] => {
  if (!category || !root) return [];
  const visit = (node: CategoryNode): string[] | undefined => {
    if (node.id === category.id) return node.name ? [node.name] : [];
    for (const child of node.children || []) {
      const path = visit(child);
      if (path) return node.id === 'root' || !node.name ? path : [node.name, ...path];
    }
    return undefined;
  };
  return visit(root) || [];
};

const matches = (...names: string[]): CategoryPredicate => (category, root, _state, path) =>
  names.some(name => (path === undefined ? productCategoryPath(category, root) : path).includes(name));

export const isFruktOrGreen = matches("Frukter, bär och grönsaker");
export const isBeverages = matches("Drycker");
export const isFoodSupplements = matches("Kosttillskott enligt definitionen i direktiv 2002/46/EG");
export const isNewFood = matches("Food");
export const isNewNonFood = matches("Non food");
export const isToy = matches("Leksak");
export const isElectric = matches("Elektrisk");
export const isJewelry = matches("Smycken, kläder, glasögon, accessoarer");
export const isGoods = matches("Varor");
export const isMedical = matches("Medicinteknik");
export const isChemical = matches("Kemiska produkter");
export const isDetergent = matches("Tvättmedel/Diskmedel");
export const isCosmetic = matches("Kosmetiska produkter");
export const isComplementarySupplements = matches("Kompletteringsfoder & Fodertillskott");
export const isSunscreen = matches("Solskyddsmedel");
export const isOTC = matches("Receptfria läkemedel");
export const isOtherFoodstuffs = matches("Övrigt livsmedel");
export const isWhiteSnus = matches("Vitt snus");
export const isSpecialFoodNutrition = matches("Livsmedel för särskilda näringsändamål");
export const isSpicesSoupsSalads = matches("Salt, kryddor, soppor, såser, sallader och proteinprodukter");
export const isMeat = matches("Kött");
export const isBakeryProducts = matches("Bageriprodukter");
export const isMilk = matches("Mjölkprodukter och motsvarande icke mjölkbaserade produkter");
export const isCereals = matches("Spannmål och spannmålsprodukter");
export const isConfectionery = matches("Konfektyrvaror");
export const isConsumptionReadySnacks = matches("Konsumtionsfärdiga snacks");
export const isSweet = matches("Sockerarter, olika former av sirap, honung och bordssötningsmedel");
export const isFats = matches("Fetter och oljor samt fett- och oljeemulsioner");
export const isIceCream = matches("Glassvaror");
export const isFeedCategory = matches("Kompletteringsfoder & Fodertillskott", "Foderråvara", "Foderblandningar", "Helfoder");
export const isCmrHazardCategory = matches("Varor", "Smycken, kläder, glasögon, accessoarer", "Leksak", "Elektrisk", "Tvättmedel/Diskmedel");
export const isPharma = matches("Kemiska produkter", "Medicinteknik", "Kosmetiska produkter", "Solskyddsmedel", "Receptfria läkemedel");
export const isElectricBattery = matches("Batterier");
export const isFish: CategoryPredicate = (category, root, state, path) =>
  matches('Fisk och fiskeriprodukter')(category, root, state, path) ||
  (state?.producerIsStore === true && matches('Egen fiskdisk')(category, root, state, path));
